module.exports = __webpack_public_path__ + "img/Character_Collei_Thumb.1cda7693.png";